module.exports = __webpack_public_path__ + "img/intro_3.23b1234c.png";